import isObject from 'lodash/isObject';
import PubSub from 'pubsub-js';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { HTMLMessage, HTMLMessageWithScroll, TextMessage } from '../models';
import { useStores } from '../stores';
import {
  MESSAGE_TYPE_RECEIVED,
  PUBSUB_MESSAGE,
  PUBSUB_MESSAGE_HTML,
  PUBSUB_MESSAGE_HTML_WITH_SCROLL,
  PUBSUB_MESSAGE_TEXT
} from '../utilities';

/**
 * @todo move to store
 */
export default function usePubSubMessaging() {
  const { chat } = useStores();
  const { t } = useTranslation();

  useEffect(() => {
    const sendMessage = message => {
      chat.isMessaging = true;

      chat.addMessage(message);
      chat.isMessaging = false;
    };

    // The previous version (useMessageScrollIntoView doesn't work well with timeout)
    // const sendMessage = (message, timeout = 300) => {
    //   chat.isMessaging = true;

    //   setTimeout(() => {
    //     chat.addMessage(message);
    //     chat.isMessaging = false;
    //   }, timeout);
    // };

    const parseMessageContent = message => {
      if (typeof message === 'string') {
        return message;
      }

      if (isObject(message) && typeof message.content === 'string') {
        if (message.message) {
          const msg = message.message + t(message.content, message.i18n);
          return msg;
        }

        // just content in object
        if (!message.i18n) {
          return message.content;
        }

        // without i18n params
        if (typeof message.i18n === 'boolean' && message.i18n) {
          return t(message.content);
        }

        // with i18n params
        if (isObject(message.i18n)) {
          return t(message.content, message.i18n);
        }
      }

      return null;
    };

    const createMessage = (topic, message) => {
      const content = parseMessageContent(message);

      if (!content) {
        return undefined;
      }

      switch (topic) {
        case PUBSUB_MESSAGE_HTML:
          return new HTMLMessage({
            type: MESSAGE_TYPE_RECEIVED,
            content
          });
        case PUBSUB_MESSAGE_HTML_WITH_SCROLL:
          return new HTMLMessageWithScroll({
            type: MESSAGE_TYPE_RECEIVED,
            content
          });
        case PUBSUB_MESSAGE_TEXT:
          return new TextMessage({
            type: MESSAGE_TYPE_RECEIVED,
            content
          });
        default:
          return undefined;
      }
    };

    PubSub.subscribe(PUBSUB_MESSAGE, (type, message) => {
      const newMessage = createMessage(type, message);

      if (newMessage) {
        sendMessage(newMessage);
      }
    });

    return () => {
      PubSub.unsubscribe(PUBSUB_MESSAGE);
    };
  }, [chat, t]);
}
